<script>

  export default {
    name:"web_scheduling_color_config_index",
    data(){
      return{
        mainSubImportLoading:false,
        columns: [
          {
            label: 'yansebianma',
            prop: 'code',
          },
          {
            label: 'yansemingchen',
            prop: 'name',
          },
          {
            label: 'shenqiandu',
            prop: 'depth',
          },
          {
            label: 'chuangjianren',
            prop: 'createByObject.nickname',
          }, {
            label: 'chuangjianshijian',
            prop: 'createTime',
            type: 'time',
          }, {
            label: 'caozuo',
            type: 'slot',
            fixed: 'right',
            width: '250'
          }
        ],
        saveFormData:{

        }
      }
    },methods:{
      searchBtn() {
        this.yt.get(1);
      },
      clear() {
        this.yt.isShowEditDialog = false
        this.saveFormData = {},
            this.issuedFormData = {}
      },
      create() {
        this.http.post("web/color/config/create", this.saveFormData).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      update() {
        this.http.post("web/color/config/update", this.yt.editObj).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      delData(row) {
        //提示是否删除
        this.$confirm('是否确定删除', this.$t('tishi'), {
          confirmButtonText: this.$t('queding'),
          cancelButtonText: this.$t('quxiao'),
          type: 'error'
        }).then(() => {
          this.http.post("web/color/config/delete", row).then((res) => {
            this.utils.successMessage(this.$t('success'))
            this.yt.get(1)
          }).catch(error => {
            this.$message.error(this.$t(error));
          }).finally(() => {
            this.clear()
          })
        }).catch(() => {

        });
      },
      mainSubImportData(){
        let data = [...this.$refs.colorConfigImportTemplate.tableData]
        if (data.length <= 0) {
          this.$message.error(this.$t('qingshangchuanwenjian'))
          return;
        }
        if (this.$refs.colorConfigImportTemplate.listLength == null || this.$refs.colorConfigImportTemplate.listLength.length == 0) {
          this.mainSubImportLoading = true;
          return this.http
              .post('/web/color/config/batchInsert?onlyValidate=false', data)
              .then(response => {
                this.utils.successMessage(this.$t(response.msg));
                this.yt.isShowEditDialog= false
                this.yt.get(1);
              })
              .catch(err => {
                this.utils.errorMessage(this.$t(err));
              }).finally(()=>{
                this.mainSubImportLoading = false;
              });
        } else {
          this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        }
      },
    },created(){
      setTimeout(() => {
        this.yt.get(1)
      }, 300);
    }
  }
</script>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/color/config/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yansebianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yansemingchen')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="searchBtn()" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng',null,'w1')">
          {{ $t('xinzeng') }}
        </el-button>

        <el-button size="mini" type="primary" @click="yt.showEditDialog('daoru',null,'w2')">
          {{ $t('daoru') }}
        </el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button type="text" @click="delData(scope.row)">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action==='daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="colorConfigImportTemplate" :templatekey="'aps_color_config_import_template'" :uploadApi="'/web/color/config/batchInsert'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action==='xinzeng'">
        <el-form :model="saveFormData" label-width="auto" ref="ruleForm" size="mini">
          <el-form-item :label="$t('yanshebianma/mingcheng')" required>
            <yi_dictionary_select size="small" :isShowValue="true" :max="1" :type="'COLOR_CONFIG'" :ids.sync="saveFormData.dictCode"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('yanseshennqian')" required>
            <el-input-number placeholder="请输入内容" v-model="saveFormData.depth" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="clear()">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="create()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action==='bianji'">
        <el-form :model="yt.editObj" label-width="auto" ref="ruleForm" size="mini">
          <el-form :model="saveFormData" label-width="auto" ref="ruleForm" size="mini">
            <el-form-item :label="$t('yanshebianma/mingcheng')" required>
              <yi_dictionary_select size="small" :isShowValue="true" :max="1" :type="'COLOR_CONFIG'" :ids.sync="yt.editObj.code" disabled> </yi_dictionary_select>
            </el-form-item>

            <el-form-item :label="$t('yanseshennqian')" required>
              <el-input-number placeholder="请输入内容" v-model="yt.editObj.depth" :min="1"></el-input-number>
            </el-form-item>
          </el-form>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="clear()">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="update()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
